export default __webpack_public_path__ + "static/media/section1-slide-A2.4cede8e3.jpg";